import { Skeleton } from '@vibe/core';

const TemplateCardSkeleton = () => (
  <div className="w-full rounded-md border border-layout p-3">
    <div className="flex gap-5">
      <div className="shrink-0 rounded-sm border border-layout p-1">
        <Skeleton width={70} height={100} />
      </div>
      <div className="w-11/12 overflow-hidden whitespace-nowrap text-lg sm:w-9/12">
        <Skeleton className="mb-2 h-5 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
    <div className="mt-5 flex flex-wrap items-center gap-2">
      <Skeleton width={60} height={32} />
      <Skeleton width={32} height={32} />
      <Skeleton width={32} height={32} />
      <Skeleton width={32} height={32} />
      <Skeleton width={32} height={32} />
    </div>
  </div>
);

export default TemplateCardSkeleton;
